export const CLASSIFICACAO_USO_FOGO_CONTROLADO = {
  potencial: "Alto",
  unidade: "ÁREA (HA)",
  descricaoAtividade:
    "Uso do fogo controlado empregado nas atividades desenvolvidas na agricultura familiar.",
  faixas: [
    { porte: "MC", descricao: "≤ 3 ha", codigo: "B" },
    { porte: "PE", descricao: "> 3 e ≤ 20 ha", codigo: "E" },
    { porte: "ME", descricao: "> 20 e ≤ 50 ha", codigo: "H" },
    { porte: "GR", descricao: "> 50 e ≤ 100 ha", codigo: "J" },
    { porte: "EX", descricao: "> 100 ha", codigo: "P" },
  ],
};

export function calcularClassificacaoUsoFogoControlado(areaHa) {
  const area = Number(areaHa);
  if (Number.isNaN(area) || area < 0) {
    return null;
  }
  if (area <= 3) return CLASSIFICACAO_USO_FOGO_CONTROLADO.faixas[0];
  if (area <= 20) return CLASSIFICACAO_USO_FOGO_CONTROLADO.faixas[1];
  if (area <= 50) return CLASSIFICACAO_USO_FOGO_CONTROLADO.faixas[2];
  if (area <= 100) return CLASSIFICACAO_USO_FOGO_CONTROLADO.faixas[3];
  return CLASSIFICACAO_USO_FOGO_CONTROLADO.faixas[4];
}
